export const SESSION_CONST = {
  ISCLIENTMODE: 'isClientMode',
  CLIENTNAME: 'clientName',
  ROLEID: 'roleId',
  CLIENTID: 'ClientId',
  ADDBULKUSERCLIENTID: 'BulkUserClientId',
  ENGAGEMENTID: 'engagementId',
  SURVEYCREATIONDATA: 'surveycreationdata',
  SELECTED_PROJECTS_ACTIVITIES: 'selectedProjectsActivities'
};
